import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PreAuthenticationGuard, ResetPasswordGuard } from '@thehubz/client/core';
import { ConfirmEmailComponent } from './components/confirm-email/confirm-email.component';
import { ContentComponent } from './components/content/content.component';
import { LoginComponent } from './components/login/login.component';
import { ResetPasswordEmailComponent } from './components/reset-password-email/reset-password-email.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpSuccessComponent } from './sign-up-success/sign-up-success.component';
import { SignUpComponent } from './sign-up/sign-up.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [PreAuthenticationGuard],
    children: [
      {
        path: 'login',
        component: SignInComponent,
      },
      {
        path: 'reset-password-email',
        component: ResetPasswordEmailComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        canActivate: [ResetPasswordGuard],
      },
      {
        path: 'sign-up',
        component: SignUpComponent,
      },
      {
        path: 'sign-up-success',
        component: SignUpSuccessComponent,
      },
      {
        path: 'confirm-email',
        component: ConfirmEmailComponent,
      },
    ],
  },
  {
    path: 'content/:param',
    component: ContentComponent,
  },
  {
    path: 'wiki/:id',
    redirectTo: '/wiki/:id',
  },
  {
    path: 'wiki',
    redirectTo: '/wiki',
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];

/**
 *  This class contain all the routing of login module
 *
 * @export
 * @class LoginRoutingModule
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
